/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
// MonthSelectorCalendar.tsx
import React, { useEffect, useRef, useState } from 'react'
import 'react-calendar/dist/Calendar.css'
import { useMonthFilter } from '../../../context/FiltersContext/MonthFilter'
import api from '../../../services/axios'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { useAuth } from '../../../context/AuthContext'
import { carregarDistribuidores } from '../../../services/dists'

export const monthNames = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

interface Distributor {
  id?: string | number
  _id?: string | number
  name?: string
  fantasy_name?: string
  nome?: string
  razao_social?: string
}

interface ModalProps {
  closeModal: () => void
}

function MonthSelectorCalendar({ closeModal }: ModalProps) {
  const { month, year, prevMonth, nextMonth, distributorId, setDistributor } = useMonthFilter()
  const { user } = useAuth()
  const ref = useRef<HTMLDivElement | null>(null)
  const [userRole, setUserRole] = useState<string | null>(null)
  const [distributors, setDistributors] = useState<Distributor[]>([])

  useEffect(() => {
    const initData = async () => {
      try {
        setUserRole(user?.role ?? null)
        setDistributors(await carregarDistribuidores())
      } catch (error) {
        console.error('Erro ao inicializar dados:', error)
      }
    }

    initData()
  }, [user])

  const handleDistributorChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    setDistributor(value === '' ? null : value)
  }

  return (
    <>
      <style>{`
        select { color: #000000 !important; background-color: #ffffff !important; }
        select option { color: #000000 !important; background-color: #ffffff !important; }
      `}</style>
      <div className='header'>
        <h2>Filtrar</h2>

        <button
          onClick={() => closeModal()}
          type='button'
          style={{
            background: 'transparent',
            position: 'absolute',
            right: 5,
            fontSize: 24,
            zIndex: 9999999999,
          }}
        >
          <IoCloseCircleSharp />
        </button>
      </div>
      <div className='body'>
        <select id='distSelect' value={distributorId ?? ''} onChange={handleDistributorChange}>
          <option value=''>Selecione o Distribuidor</option>
          {distributors.map((distributor: any) => {
            const id = distributor.id || distributor._id
            const name = distributor.fantasy_name || distributor.name || distributor.nome || distributor.razao_social || 'Distribuidor'
            return (
              <option key={id} value={id}>
                {name}
              </option>
            )
          })}
        </select>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center', width: '100%' }}>
          <button
            className='buttons'
            type='button'
            onClick={prevMonth}
            style={{
              flex: 1,
              boxShadow: '0px 2px 20px 1px rgba(0, 0, 0, 0.2)',
              background: '#E9E9ED',
              color: '#001842ff',
            }}
          >
            ◀
          </button>

          <button
            className='buttons'
            type='button'
            style={{
              flex: 6,
              boxShadow: '0px 2px 20px 1px rgba(0, 0, 0, 0.2)',
              background: '#E9E9ED',
              color: '#001842ff',
            }}
          >
            {monthNames[month]} {year}
          </button>

          <button
            className='buttons'
            type='button'
            onClick={nextMonth}
            style={{
              flex: 1,
              boxShadow: '0px 2px 20px 1px rgba(0, 0, 0, 0.2)',
              background: '#E9E9ED',
              color: '#001842ff',
            }}
          >
            ▶
          </button>
        </div>
      </div>
    </>
  )
}

export default MonthSelectorCalendar
